function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.4062 4.9375L13.0625 2.59375C12.6875 2.21875 12.1875 2 11.6562 2H6C4.875 2 4 2.90625 4 4V16C4 17.125 4.875 18 6 18H14C15.0938 18 16 17.125 16 16V6.34375C16 5.8125 15.7812 5.3125 15.4062 4.9375ZM14.5 16C14.5 16.2813 14.25 16.5 14 16.5H6C5.71875 16.5 5.5 16.2813 5.5 16V4.03125C5.5 3.75 5.71875 3.53125 6 3.53125H11V6C11 6.5625 11.4375 7 12 7H14.4688V16H14.5ZM7 10.75C7 11.1875 7.3125 11.5 7.75 11.5H12.25C12.6562 11.5 13 11.1875 13 10.75C13 10.3438 12.6562 9.99999 12.25 9.99999H7.75C7.3125 9.99999 7 10.3438 7 10.75ZM12.25 13H7.75C7.3125 13 7 13.3438 7 13.75C7 14.1875 7.3125 14.5 7.75 14.5H12.25C12.6562 14.5 13 14.1875 13 13.75C13 13.3438 12.6562 13 12.25 13Z",
  fill: "currentColor"
});

const SvgPage = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/page.57019b21.svg";
export { ForwardRef as ReactComponent };